import { connect, ConnectedProps } from 'react-redux'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
